import React from 'react';
import type { KpiCard } from '@ctd/agent-contract';
import { KpiCardShell } from '~analytics-components/kpi-card-shell';
import { formatCalendarDate } from '../utils/card-format';
import { CardNotes } from './card-notes';
import { OtherMetrics } from './other-metrics';
import style from '../style.module.scss';

/** The chrome and the states every shape shares: warnings, other metrics, freshness, not available. */
export const CardFrame: React.FC<{
    card: KpiCard;
    size?: 'sm' | 'lg';
    children: React.ReactNode;
}> = ({ card, size = 'lg', children }) => {
    const hasWarnings = card.warnings.length > 0;
    const shell = (
        <KpiCardShell
            title={card.title}
            subtitle={card.subtitle}
            size={size}
            info={
                hasWarnings ? <CardNotes warnings={card.warnings} /> : undefined
            }
            infoTone={hasWarnings ? 'warning' : undefined}
        >
            {card.unavailable ? (
                <div className={style.card_state}>
                    <span className={style.card_state_title}>
                        Not available
                    </span>
                    <span>{card.unavailable.reason}</span>
                </div>
            ) : (
                <>
                    {children}
                    <OtherMetrics metrics={card.others} />
                </>
            )}
            {card.dataCompleteThrough && (
                <p className={style.card_footer}>
                    {`Data through ${formatCalendarDate(
                        card.dataCompleteThrough
                    )}`}
                </p>
            )}
        </KpiCardShell>
    );

    return size === 'lg' ? (
        <div className={style.wide_card}>{shell}</div>
    ) : (
        shell
    );
};
